import React, { useState } from 'react';
import "../../css/ScrollToTop.css";
import arrowUp from "../../images/up-arrow.png";
const ScrollToTop = () => {

    const [isTrue, setIsTrue] = useState(false);
    window.addEventListener("scroll", () => {
        window.scrollY > 300 ? setIsTrue(true) : setIsTrue(false);
    })

    return (
        <a  href="#" className={`${isTrue ? "show-btn": "hide-btn"} scroll__to__top shadow-sm`}>
            <img src={arrowUp} alt="arrow-up" />
        </a>
    )
}

export default ScrollToTop
